module.exports = __webpack_public_path__ + "img/ice-tea.aa90fb9e.png";